export const supportedBrowsers = [{
    name: 'Chrome',
    version: 'v72+',
    imgSrc: '/images/unsupported/chrome.svg',
}, {
    name: 'Firefox',
    version: 'v65+',
    imgSrc: '/images/unsupported/firefox.svg',
}, {
    name: 'Edge',
    version: 'v79+',
    imgSrc: '/images/unsupported/edge.svg',
}];

export const viewController = {
    NOT_STARTED: 'NOT_STARTED',
    AUTO_ACCESS: 'AUTO_ACCESS',
    NEWROW_IFRAME: 'NEWROW_IFRAME',
    WEBCASTING: 'WEBCASTING',
    EMBEDDED: 'EMBEDDED',
    EXTERNAL: 'EXTERNAL',
    SIMULIVE: 'SIMULIVE',
    ZOOM: 'ZOOM',
    BROWSER_NOT_SUPPORTED: 'BROWSER_NOT_SUPPORTED',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    SESSION_RESTRICTED: 'SESSION_RESTRICTED',
    PRE_ROLL: 'PRE_ROLL',
    THIRD_PARTY_COOKIES_BLOCKED: 'THIRD_PARTY_COOKIES_BLOCKED',
    VIDEO_PROVIDER: 'VIDEO_PROVIDER',
    INTERACTIVE_VIDEO_PROVIDER: 'INTERACTIVE_VIDEO_PROVIDER',
};

export const broadcastTypes = [
    viewController.EMBEDDED,
    viewController.WEBCASTING,
    viewController.NEWROW_IFRAME,
    viewController.SIMULIVE,
    viewController.VIDEO_PROVIDER,
    viewController.INTERACTIVE_VIDEO_PROVIDER,
    viewController.AUTO_ACCESS,
];

export const checkInSend = true;

